import { createAction, props } from '@ngrx/store';
import { IRetirementPlanRequest, IRetirementPlan } from '../models/retirement-plan.model';

export const loadRetirementPlan = createAction('[Retirement Plan] Load Retirement Plan', props<{ request: IRetirementPlanRequest }>());

export const loadRetirementPlanSuccess = createAction(
  '[Retirement Plan] Load Retirement Plan Success',
  props<{ response: IRetirementPlan }>()
);

export const loadRetirementPlanFailure = createAction('[Retirement Plan] Load Retirement Plan Failure', props<{ error: Error | any }>());
